module.exports = __webpack_public_path__ + "static/img/performance05.fa522bdf.jpg";